module.exports = __webpack_public_path__ + "style/img/DI_icon_Dev.f6659d19.png";